"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KicadModule = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const kicad_module_parser_1 = require("kicad-module-parser");
const utils_1 = require("./utils");
const layer_1 = require("./layer");
const colors_1 = require("./colors");
const slider_1 = __importDefault(require("./slider"));
const FRONT_LAYERS = ["F.Cu", "F.Adhes", "F.Paste", "F.SilkS", "F.Mask", "F.CrtYd", "F.Fab"];
const BACK_LAYERS = ["F.Cu", "F.Adhes", "F.Paste", "F.SilkS", "F.Mask", "F.CrtYd", "F.Fab"];
const USER_LAYERS = ["Dwgs.User", "Cmts.User", "Eco1.User", "Eco2.User", "Edge.Cuts"];
const STANDARD_LAYERS = [...FRONT_LAYERS, ...BACK_LAYERS, ...USER_LAYERS];
// const randomColor = () => "#" + Math.floor(Math.random() * 16777215).toString(16);
class Module {
    constructor() {
        this._layers = {};
        this.layers = new Proxy(this._layers, {
            // @ts-ignore (keyof layerset is a string)
            get: (target, prop, receiver) => {
                if (!(prop in target)) {
                    target[prop] = {
                        text: [],
                        pads: [],
                        shapes: [],
                        color: colors_1.BOARD_COLORS[prop]
                    };
                }
                return Reflect.get(target, prop, receiver);
            }
        });
    }
}
// const Data = styled.div`
// font-family: 'Roboto Mono', monospace;
// `
const Drawing = styled_components_1.default.div `
position: relative;
height: calc(100vh - 5rem);
`;
//height: calc(100% - 4rem);
const Layers = styled_components_1.default.div `
position: absolute;
`;
const Svg = styled_components_1.default.svg `
background-color: black;
position: absolute;
max-height: 100%;
font-family: 'Jura', sans-serif;
`;
const reFrontBack = /^([FB])\./;
const Row = styled_components_1.default.div `
display: flex;
flex-direction: row;
align-items: flex-start;
`;
const KicadModule = ({ module }) => {
    const data = kicad_module_parser_1.parse_module(module);
    const _module = new Module();
    let minxy = undefined;
    let maxxy = undefined;
    const minmax = (x) => {
        if (!minxy || !maxxy) {
            minxy = [x[0], x[1]];
            maxxy = [x[0], x[1]];
            return;
        }
        if (x[0] < minxy[0]) {
            minxy[0] = x[0];
        }
        if (x[1] < minxy[1]) {
            minxy[1] = x[1];
        }
        if (x[0] > maxxy[0]) {
            maxxy[0] = x[0];
        }
        if (x[1] > maxxy[1]) {
            maxxy[1] = x[1];
        }
    };
    data.text.forEach(text => {
        if (text.layers)
            for (let _layer of text.layers) {
                let LAYER = _module.layers[_layer];
                LAYER.text.push(text);
            }
    });
    data.pads.forEach(pad => {
        if (pad.layers)
            for (let _layer of pad.layers) {
                let LAYER = _module.layers[_layer];
                LAYER.pads.push(pad);
            }
    });
    data.shapes.forEach((x) => {
        let R;
        if (x.layers) {
            for (let _layer of x.layers) {
                _module.layers[_layer].shapes.push(x);
            }
        }
        else {
            console.log('[react-kicad-module] unknown layers: ' + JSON.stringify(x));
        }
        switch (x.type) {
            case "fp_line":
                minmax(x.start);
                minmax(x.end);
                break;
            case "fp_arc":
                R = utils_1.len(x.center, x.end);
                minmax(utils_1.add(x.center, [R, R]));
                minmax(utils_1.add(x.center, utils_1.multiply(-1, [R, R])));
                break;
            case "fp_circle":
                R = utils_1.len(x.center, x.end);
                minmax(utils_1.add(x.center, [R, R]));
                minmax(utils_1.add(x.center, utils_1.multiply(-1, [R, R])));
                break;
            case "fp_poly":
                x.points.forEach(x => minmax(x));
                break;
            case "fp_curve":
                minmax(x.start);
                minmax(x.control1);
                minmax(x.control2);
                minmax(x.end);
                break;
        }
    });
    minxy = minxy || [0, 0];
    maxxy = maxxy || [1, 1];
    const expander = utils_1.multiply(0.3, utils_1.diff(maxxy, minxy));
    minxy = utils_1.diff(minxy, expander);
    maxxy = utils_1.add(expander, maxxy);
    const hw = utils_1.add(maxxy, utils_1.multiply(-1, minxy));
    // for (const [key, value] of Object.entries(_module._layers)) {
    //     console.log(`[react-kicad-module] ${key}: ${value}`);
    // }
    const INITIAL_LAYER_ORDER = {
        "F": FRONT_LAYERS,
        "B": BACK_LAYERS,
        "O": [...USER_LAYERS, ...Object.keys(_module._layers).filter(x => STANDARD_LAYERS.indexOf(x) === -1)]
    };
    const [LayerOrders, setLayerOrders] = react_1.useState(INITIAL_LAYER_ORDER);
    const [showLayer, setShowLayer] = react_1.useState(Object.fromEntries(Object.keys(_module._layers).map(x => [x, true])));
    const [layerStackingOrder, setLayerStackingOrder] = react_1.useState(["F", "B", "O"]);
    // alert(`current stack order ${JSON.stringify(layerStackingOrder)} ` )
    const [activeLayer, _setActiveLayer] = react_1.useState("F.Cu");
    const setActiveLayer = (x) => {
        // set the active layer group
        let re_val = reFrontBack.exec(x);
        let layerGroupName = (re_val ? re_val[1] : "O");
        let indx = layerStackingOrder.indexOf(layerGroupName);
        if (indx !== 0) {
            let newLayerGroupOrder = [layerGroupName, ...layerStackingOrder.slice(0, indx), ...layerStackingOrder.slice(indx + 1),];
            // alert(`setting stack order from ${JSON.stringify(layerGroupName)} to ${JSON.stringify(newLayerGroupOrder)} ` )
            setLayerStackingOrder(newLayerGroupOrder);
        }
        // alert("actually setting active layer: " + x)
        // set the active layer
        _setActiveLayer(x);
    };
    const zref = {};
    const getZ = (x) => {
        if (x in zref)
            return zref[x];
        let re_val = reFrontBack.exec(x);
        let layerGroupName = (re_val ? re_val[1] : "O");
        let lg = LayerOrders[layerGroupName];
        if (typeof lg === "undefined") {
            console.log(`[react-kicad-module] unknown layer group name ${layerGroupName} of ${JSON.stringify(Object.keys(LayerOrders))}`);
            return 0;
        }
        if (lg.indexOf(x) === -1) {
            lg = [x, ...lg];
            let newlayerOrders = { ...LayerOrders };
            newlayerOrders[layerGroupName] = lg;
            setLayerOrders(newlayerOrders);
        }
        const z = (lg.indexOf(x) +
            100 * (3 - layerStackingOrder.indexOf(layerGroupName)) +
            ((activeLayer === x) ? 1000 : 0));
        // alert(`layer: ${x} -- z: ${z}`)
        return z;
    };
    const ref = react_1.useRef(null);
    const [contianerHeight, setContianerHeight] = react_1.useState("1000px");
    // INITIAL ELEMENT WIDTH
    react_1.useEffect(() => {
        const current = ref.current;
        if (current) {
            setContianerHeight(`${Math.ceil(current.offsetWidth * hw[1] / hw[0]) + 10}px`);
        }
    }, [ref.current]);
    // ELEMNT WIDTN ON RESIZE
    window.addEventListener('resize', () => {
        const current = ref.current;
        if (current) {
            setContianerHeight(`${Math.ceil(current.offsetWidth * hw[1] / hw[0]) + 10}px`);
        }
    });
    return (react_1.default.createElement("div", { ref: ref, style: {
            position: "relative",
            height: contianerHeight
        } },
        react_1.default.createElement(Svg, { xmlns: "http://www.w3.org/2000/svg", viewBox: `${minxy[0]} ${minxy[1]} ${hw[0]} ${hw[1]} ` }, Object.entries(_module._layers)
            .filter(x => showLayer[x[0]])
            .sort((x, y) => getZ(x[0]) - getZ(y[0]))
            .map(entry => react_1.default.createElement(layer_1.Layer, { key: entry[0], layer: entry[1], z: 0 }))),
        react_1.default.createElement(Layers, null,
            react_1.default.createElement("ul", { style: { listStyleType: 'none', margin: "0px", paddingLeft: "1.3rem", paddingTop: "1.3rem" } },
                " ",
                Object.keys(_module._layers)
                    .map(x => {
                    const color = _module.layers[x].color;
                    return (react_1.default.createElement("li", { key: x, style: { color: color, cursor: "default" }, onClick: (ev) => {
                            ev.stopPropagation();
                            ev.preventDefault();
                            setActiveLayer(x);
                        } },
                        react_1.default.createElement(Row, null,
                            react_1.default.createElement(slider_1.default, { activeColor: color, checked: showLayer[x], onClick: (ev) => {
                                    ev.stopPropagation();
                                    ev.preventDefault();
                                    const sl = { ...showLayer };
                                    sl[x] = !sl[x];
                                    setShowLayer(sl);
                                }, onChange: (ev) => {
                                    ev.stopPropagation();
                                    ev.preventDefault();
                                    const sl = { ...showLayer };
                                    sl[x] = ev.target.checked;
                                    setShowLayer(sl);
                                } }),
                            react_1.default.createElement("span", { style: { marginTop: "0.2rem", verticalAlign: "center" } }, x))));
                }),
                " "))));
};
exports.KicadModule = KicadModule;
exports.default = exports.KicadModule;
